import Swiper from 'swiper';
import { FreeMode, Mousewheel, Navigation, Scrollbar } from 'swiper/modules';

function initSliderSwiper(element) {
	const prevEl = element.querySelector('.slider-container__prev');
	const nextEl = element.querySelector('.slider-container__next');
	const scrollbarEl = element.querySelector('.swiper-scrollbar');

	return new Swiper(element, {
		modules: [FreeMode, Mousewheel, Navigation, Scrollbar],
		slidesPerView: 'auto',
		freeMode: {
			enabled: true,
			momentum: true,
		},
		grabCursor: true,
		spaceBetween: 16,
		slidesOffsetBefore: 20,
		slidesOffsetAfter: 80,
		watchOverflow: true,
		breakpoints: {
			1200: {
				spaceBetween: 32,
				slidesOffsetBefore: 160,
				slidesOffsetAfter: 160,
			},
		},
		navigation:
			prevEl || nextEl
				? {
						prevEl,
						nextEl,
					}
				: undefined,
		mousewheel: {
			forceToAxis: true,
			sensitivity: 1,
		},
		scrollbar: scrollbarEl
			? {
					el: scrollbarEl,
					draggable: true,
					hide: false,
				}
			: undefined,
		threshold: 8,
		touchStartPreventDefault: false,
	});
}

export default function initSliderSwipers() {
	document.querySelectorAll('.slider-swiper').forEach((element) => {
		initSliderSwiper(element);
	});
}
